import { LibraryObject } from "./library";
import { InputFieldConfiguration } from "./InputFieldConfiguration";
import { getKeyWithoutSlash } from "./../services/content";
import { User } from "./user";

interface S3Object {
  key: string;
  prefix: string;
  name: string;
  isPrivate: boolean;
  libraryObject?: LibraryObject;
}

// eslint-disable-next-line no-shadow
export enum FolderRootType {
  ADMIN_CONTENT = "admin-content",
  EXERCISE = "exercise",
}

export const ASSETS_FOLDER_NAME = "assets";
export const EDITOR_FILE_NAME = "editor.json";
export const EXERCISES_FOLDER_ROOT = "exercises";

export function getExercisesRootFolder(sessionUser: User) {
  if (!sessionUser.instructor) {
    throw new Error("The user is not an instructor");
  }
  return EXERCISES_FOLDER_ROOT + "/" + sessionUser.instructor.id + "/";
}

export interface Folder extends S3Object {}

export class FolderUI {
  label: string = "Folder";
  uiFormFields: { [fieldName: string]: InputFieldConfiguration } = {
    name: {
      label: "Name",
      required: true,
      maxLength: 128,
      isVisible: true,
    },
    description: {
      label: "Description",
      required: false, //true,
      maxLength: 512,
      isVisible: true,
    },
    author: {
      label: "Author",
      required: false, //true,
      maxLength: 128,
      isVisible: true,
    },
    preview: {
      type: "file",
      label: "Icon (Square)",
      required: false, //true,
      isVisible: true,
    },
    preview_vertical: {
      type: "file",
      label: "Icon (Vertical)",
      required: false, //true,
      isVisible: true,
    },
    preview_horizontal: {
      type: "file",
      label: "Icon (Horizontal)",
      required: false, //true,
      isVisible: true,
    },
    order: {
      type: "number",
      label: "Order",
      required: false,
      isVisible: true,
    },
    length: {
      type: "number",
      label: "Length",
      required: false,
      isVisible: true,
    },
    subtype: {
      label: "Sub Type",
      required: false,
      isVisible: true,
    },
    readings: {
      type: "number",
      label: "Readings",
      required: false,
      isVisible: true,
    },
    videos: {
      type: "number",
      label: "Videos",
      required: false,
      isVisible: true,
    },
  };
  isAddContentButtonVisible: boolean = false;
  nextLevelFolderUI: FolderUI = {
    label: "Folder",
  } as FolderUI;
}

export class ContentSourceFolderUI extends FolderUI {
  constructor() {
    super();
    this.label = "Source";
  }
}

export class ExerciseFolderUI extends FolderUI {
  constructor() {
    super();
    this.label = "Folder";
    this.uiFormFields.description.required = false;
    this.uiFormFields.description.isVisible = false;
    this.uiFormFields.author.required = false;
    this.uiFormFields.author.isVisible = false;
    this.uiFormFields.preview.required = false;
    this.uiFormFields.preview.isVisible = false;
    this.uiFormFields.preview_vertical.isVisible = false;
    this.uiFormFields.preview_horizontal.isVisible = false;
    this.uiFormFields.order.isVisible = false;
  }
}

export function getFolderUIClass(key: string) {
  let folderUIClass = new FolderUI();
  folderUIClass.nextLevelFolderUI = new FolderUI();
  if (key === "") {
    folderUIClass.nextLevelFolderUI = new ContentSourceFolderUI();
  } else if (key.indexOf("/") > -1) {
    key = getKeyWithoutSlash(key);
    const parts = key.split("/");
    const firstParent = parts[0];
    if (firstParent.toLowerCase().indexOf("cambridge") > -1) {
      // We don't use this details now and let admins do what they want to do.
      // if (parts.length === 1) {
      //   folderUIClass = new ContentSourceFolderUI();
      //   folderUIClass.nextLevelFolderUI = new CambridgeBookFolderUI();
      // } else if (parts.length === 2) {
      //   folderUIClass = new CambridgeBookFolderUI();
      // } else if (parts.length === 3) {
      //   folderUIClass = new CambridgeChapterFolderUI();
      // }
    } else if (firstParent.toLowerCase().indexOf("bloomberg") > -1) {
      // We don't use this details now and let admins do what they want to do.
      // if (parts.length === 1) {
      //   folderUIClass = new ContentSourceFolderUI();
      //   folderUIClass.nextLevelFolderUI = new BloombergTopicFolderUI();
      // } else if (parts.length === 2) {
      //   folderUIClass = new BloombergTopicFolderUI();
      // } else if (parts.length === 3) {
      //   folderUIClass = new BloombergArticleFolderUI();
      // }
    } else if (firstParent.toLowerCase().indexOf("talaera") > -1) {
      // We don't use this details now and let admins do what they want to do.
      // if (parts.length === 1) {
      //   folderUIClass = new ContentSourceFolderUI();
      //   folderUIClass.nextLevelFolderUI = new TalaeraCourseFolderUI();
      // } else if (parts.length === 2) {
      //   folderUIClass = new TalaeraCourseFolderUI();
      // } else if (parts.length === 3) {
      //   folderUIClass = new TalaeraCourseTopicFolderUI();
      // } else if (parts.length === 4) {
      //   folderUIClass = new TalaeraCourseItemFolderUI();
      // }
    } else if (firstParent.toLowerCase().indexOf(EXERCISES_FOLDER_ROOT) > -1) {
      folderUIClass = new ExerciseFolderUI();
      folderUIClass.nextLevelFolderUI = new ExerciseFolderUI();
    }
  }
  return folderUIClass;
}

export interface File extends S3Object {
  lastModified?: Date;
}
